import React, {useEffect, useState} from "react";
import {Form, Input, Modal, Select} from "antd";
import {useFormik} from "formik";
import * as yup from "yup";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../../hooks/useStore";
import {arrayAlphabeticalSort} from "../../../../../utils/helpers";
import {EquipmentVariationsInput} from "../../../components/equipmentVariationsInput/EquipmentVariationsInput";
export const CreateEquipmentModal = ({
    visibility,
    recall = () => {},
    onOk = () => {},
    onCancel = () => {},
    changeVisibility = () => {}
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();
    const [equipmentTypeOptions, setEquipmentTypeOptions] = useState([]);
    const [reloadVariationsInput, setReloadVariationsInput] = useState(false);

    const handleCancel = () => {
        changeVisibility(false);
        onCancel();
    };

    useEffect(() => {
        if (visibility) {
            resetForm();
            setEquipmentTypeOptions(
                arrayAlphabeticalSort([...stores.equipmentStore.equipmentTypes], "name")
            );
            setReloadVariationsInput(!reloadVariationsInput);
        }
    }, [JSON.stringify(stores?.equipmentStore?.equipmentTypes), visibility]);

    const formik = useFormik({
        initialValues: {name: "", typeId: undefined, variations: []},
        validationSchema: yup.object().shape({
            name: yup.string().required(t("validation.required", {ns: "common"})),
            typeId: yup.string().required(t("validation.required", {ns: "common"})),
            variations: yup
                .array()
                .min(1, "En az bir tane ekipman özelliği eklemelisiniz.")
                .required(t("validation.required", {ns: "common"})),
            brand: yup.string().required(t("validation.required", {ns: "common"}))
        }),
        onSubmit: async values => {
            const variations = values?.variations.map(variation => ({
                color: variation?.color,
                size: variation?.size,
                price: variation?.price,
                externalId: variation?.externalId
            }));
            const payload = {
                name: values.name,
                typeId: values.typeId,
                brand: values.brand,
                externalId: values.externalId,
                variations
            };
            try {
                const response = await stores.equipmentStore.createEquipment(payload);
                if (response) {
                    recall();
                    setReloadVariationsInput(!reloadVariationsInput);
                    changeVisibility(false);
                    resetForm();
                    onOk();
                }
            } catch (e) {}
        },
        enableReinitialize: true
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        resetForm,
        setFieldValue
    } = formik;

    return (
        <Modal
            title={"Yeni Ekipman Oluştur"}
            confirmLoading={isSubmitting}
            visible={visibility}
            onOk={handleSubmit}
            onCancel={handleCancel}
            okText="Oluştur"
            cancelText="İptal"
            width={750}
        >
            <Form
                autoComplete="off"
                labelCol={{span: 24}}
                wrapperCol={{span: 24}}
                style={{width: "100%"}}
            >
                <Form.Item
                    label={"Ekipman Adı"}
                    validateStatus={errors.name && touched.name ? "error" : "success"}
                    help={errors.name && touched.name ? errors.name : null}
                >
                    <Input
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        placeholder={"Vigo Kaskı, Vigo Montu vb."}
                        autoFocus
                        onPressEnter={handleSubmit}
                    />
                </Form.Item>
                <Form.Item
                    label={"Ekipman Tipi"}
                    validateStatus={errors.typeId && touched.typeId ? "error" : "success"}
                    help={errors.typeId && touched.typeId ? errors.typeId : null}
                >
                    <Select
                        name="typeId"
                        data-testid="equipmentTypeSelect"
                        value={values.typeId}
                        onChange={value => setFieldValue("typeId", value)}
                        placeholder={"Ekipman Tipi Seçiniz"}
                        showSearch
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                            option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {equipmentTypeOptions.map(equipmentType => (
                            <Select.Option
                                key={equipmentType._id}
                                value={equipmentType._id}
                                data-testid="equipmentTypeSelect_option"
                            >
                                {equipmentType?.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label={"Marka"}
                    validateStatus={errors.brand && touched.brand ? "error" : "success"}
                    help={errors.brand && touched.brand ? errors.brand : null}
                >
                    <Input
                        name="brand"
                        value={values.brand}
                        onChange={handleChange}
                        placeholder={"Marka"}
                        autoFocus
                        onPressEnter={handleSubmit}
                    />
                </Form.Item>
                <Form.Item
                    label={"Ekipman External ID"}
                    validateStatus={errors.externalId && touched.externalId ? "error" : "success"}
                    help={errors.externalId && touched.externalId ? errors.externalId : null}
                >
                    <Input
                        name="externalId"
                        value={values.externalId}
                        onChange={handleChange}
                        placeholder={"Ekipman External ID"}
                        autoFocus
                        onPressEnter={handleSubmit}
                    />
                </Form.Item>
                <Form.Item
                    label={"Ekipman Varyasyonları"}
                    validateStatus={errors.variations && touched.variations ? "error" : "success"}
                    help={errors.variations && touched.variations ? errors.variations : null}
                >
                    <EquipmentVariationsInput
                        variations={values.variations}
                        setVariations={variations => setFieldValue("variations", variations)}
                        refreshInput={reloadVariationsInput}
                        visibility={visibility}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
